import React, {Component} from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import Good from '../../good/Good'

const Goods = styled.div`
  ${({viewType}) => viewType === 'cards'
    ? css`
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: stretch;
      margin-left: -23px;
    ` : css`
      display: block;
    `
  }
  padding-bottom: 20px;
`

const NothingFound = styled.div`
  margin-top: 20px;
  font: 16px/1.7 raleway, sans-serif;
  font-weight: 500;
  color: #333;
`

const INIT_NUM_OF_DISPLAYED_GOODS = 20

let globalNumOfDisplayedGoods = null

class GoodListController extends Component {
  state = {
    numOfDisplayedGoods: globalNumOfDisplayedGoods || INIT_NUM_OF_DISPLAYED_GOODS,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.viewType !== this.props.viewType
      || prevProps.activeCategory !== this.props.activeCategory
      || prevProps.searchQuery !== this.props.searchQuery
    ) {
      this.reInitNumOfDisplayedGoods()
    }
  }

  reInitNumOfDisplayedGoods = () => {
    globalNumOfDisplayedGoods = INIT_NUM_OF_DISPLAYED_GOODS
    this.setState({
      numOfDisplayedGoods: INIT_NUM_OF_DISPLAYED_GOODS
    })
  }

  increaseNumOfDisplayedGoods = (callback) => {
    const numOfDisplayedGoods = this.state.numOfDisplayedGoods
    const newNumOfDisplayedGoods =  numOfDisplayedGoods + 20
    globalNumOfDisplayedGoods = newNumOfDisplayedGoods
    this.setState({
      numOfDisplayedGoods: newNumOfDisplayedGoods
    }, callback)
  }

  handleScroll = () => {
    if (this.scrollProcessing) return
    this.scrollProcessing = true

    const bottom = this.refs.root.getBoundingClientRect().bottom
    if (bottom <= window.innerHeight * 2) {
      const numOfDisplayedGoods = this.state.numOfDisplayedGoods
      if (this.props.goods.length > numOfDisplayedGoods) {
        this.increaseNumOfDisplayedGoods(() => this.scrollProcessing = false)
      } else {
        this.scrollProcessing = false
      }
    } else {
      this.scrollProcessing = false
    }
  }

  getGoodList() {
    let searchRegExp = null
    if (this.props.searchQuery) {
      const cleanQuery = this.props.searchQuery.replace(/[^0-9а-яa-z]/i, '')
      searchRegExp = new RegExp(cleanQuery, 'i')
    }

    let count = 0
    let index = 0
    const goodList = []
    while (index < this.props.goods.length && count < this.state.numOfDisplayedGoods) {
      const good = this.props.goods[index]

      let inCategory = true
      const activeCategoryId = this.props.activeCategory ? this.props.activeCategory.id : null
      if (activeCategoryId) {
        const category = good.categories.find(category => category.id === activeCategoryId)
        if (!category) inCategory = false
      }

      if (inCategory) {
        let found = true
        if (searchRegExp) {
          const searchString = `${good.trimmedTitle} ${good.trimmedDescription}`
          if (!searchString.match(searchRegExp)) found = false
        }

        if (found) {
          goodList.push(<Good
            key={good.id}
            good={good}
            quantityInCart={this.props.cart[good.id] || 0}
            setQuantityInCart={(quantity) => this.props.setQuantityInCart(good, quantity)}
            currentUser={this.props.currentUser}
            activeCatalogType={this.props.activeCatalogType}
            activeCategory={this.props.activeCategory}
            viewType={this.props.viewType}
          />)
          count++
        }
      }
      index++
    }

    return goodList
  }

  render() {
    const goods = this.getGoodList()

    if (!goods.length) {
      let msg = <span>Ничего не найдено. Попробуйте изменить запрос или поискать<br/> по другим программам.</span>

      if (this.props.activeCategory) {
        msg = <span>Ничего не найдено. Попробуйте изменить запрос или поискать<br/>
          {this.props.activeCatalogType.getRootSearchLink()}.</span>
      }

      return <NothingFound>
        {msg}
      </NothingFound>
    }

    return <Goods ref="root" viewType={this.props.viewType}>
      {goods}
    </Goods>
  }
}

export default GoodListController
